import t from "../locales";

export default function CharacterCard({ characterKey, photo }) {
  return (
    <div className="character-card">
      <div className="character-card__photo">
        <img className="character-card__image" src={photo} alt="" />
        <p className="character-card__nameplate">
          {t(`characters.names.${characterKey}`)}
        </p>
      </div>
    </div>
  );
}
